import { ActionCreatorWithPayload, Store } from '@reduxjs/toolkit';

import { IncomingHttpHeaders } from 'http';

import { isMobile } from '@nocowanie/core/helpers';

import { environment } from '@app/environments/environment';

export const setMobile = ({
    userAgent,
    store,
    action,
}: {
    userAgent: IncomingHttpHeaders['user-agent'];
    store: Store;
    action: ActionCreatorWithPayload<any>;
}) => {
    const isMobileDevice = isMobile(userAgent);
    store.dispatch(action(isMobileDevice));
};

export const getAssetUrl = (path: string, baseUrl = environment.CEPH_URL): string => {
    const assetUrl = `${baseUrl}/${path}`;
    return assetUrl;
};

export const runWhenIdle = (callback: () => void): void => {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => callback());
    } else {
        setTimeout(callback, 1);
    }
};
